/**
 * HHT2 TimeLine Contents 정보
 * @type {string[]}
 */

export const HHT2_EP5_ANSWERS = [
    'Harry is reading a book in the playroom, but Holly and Tony are bored.\n',
    'Tony remembers the baseball equipment on the wall and says, “We can play baseball!”\n',
    'Holly thinks that’s a great idea, but Harry thinks Matt won’t be happy.\n',
    'Still, Holly, Harry, and Tony take the baseball equipment to the park with Stephanie.\n',
    'At the baseball field, Tony decides to pitch, Holly will catch, Stephanie will bat, and Harry will be the umpire.\n',
    'Back at the house, Matt is shocked because the baseball equipment is gone!\n”',
    'Meanwhile, the kids and Stephanie are playing baseball. Stephanie hits a home run!\n',
    'In the house, Matt can’t find the baseball equipment anywhere! So, he calls Stephanie.\n',
    'But Stephanie tells Matt, “We’re using my baseball equipment right now.”\n',
    'The kids are surprised because the baseball equipment isn’t Matt’s! It’s Stephanie’s!\n',
];

// export const HHT2_EP5_ANSWER_SOUNDS = [
//     '/HHT2_AB EP05_dyr01.mp3',
//     '/HHT2_AB EP05_dyr02.mp3',
//     '/HHT2_AB EP05_dyr03.mp3',
//     '/HHT2_AB EP05_dyr04.mp3',
//     '/HHT2_AB EP05_dyr05.mp3',
//     '/HHT2_AB EP05_dyr06.mp3',
//     '/HHT2_AB EP05_dyr07.mp3',
//     '/HHT2_AB EP05_dyr08.mp3',
//     '/HHT2_AB EP05_dyr09.mp3',
//     '/HHT2_AB EP05_dyr10.mp3',
// ];

export const HHT2_EP5_ANSWER_SOUNDS = [
    '/4be42f9afe9633d6a57259ae6d29e98a.mp3',
    '/994d1c31e43badb8fdfe74bfcb08d235.mp3',
    '/afaa891c0f8ef060cb7c14e09138bea4.mp3',
    '/874709d58e7d24d9f6ea9d481133a9a1.mp3',
    '/e03aed7c62e201c4883dfffb27fcfcde.mp3',
    '/a3379a669e84aa08addd4304c8bebe96.mp3',
    '/a9267298f25a8cea444d2209d239aebf.mp3',
    '/ada4e9a9b537eef1b90dee6ea3e948db.mp3',
    '/22fa6147432adb9f437bc358f61e6048.mp3',
    '/19e2b2a53141eacc9ccc04d1af203270.mp3',
];


export const HHT2_EP5_QUIZ_ITEMS = [{
    'A': HHT2_EP5_ANSWERS[1],
    'B': HHT2_EP5_ANSWERS[8],
    'SoundIndexA': 1,
    'SoundIndexB': 8,
    'answer': HHT2_EP5_ANSWERS[1],
    'sound': [2, 3],
    'exception': false,
},
    {
        'A': HHT2_EP5_ANSWERS[4],
        'B': HHT2_EP5_ANSWERS[0],
        'SoundIndexA': 4,
        'SoundIndexB': 0,
        'answer': HHT2_EP5_ANSWERS[4],
        'sound': [5, 6],
        'exception': false,
    },
    {
        'A': HHT2_EP5_ANSWERS[2],
        'B': HHT2_EP5_ANSWERS[7],
        'SoundIndexA': 2,
        'SoundIndexB': 7,
        'answer': HHT2_EP5_ANSWERS[7],
        'sound': [8],
        'exception': false,
    },
    {
        'A': HHT2_EP5_ANSWERS[9],
        'B': HHT2_EP5_ANSWERS[3],
        'SoundIndexA': 9,
        'SoundIndexB': 3,
        'answer': HHT2_EP5_ANSWERS[9],
        'sound': [9],
        'exception': false,
    },
]
